import { Link } from 'react-router-dom'
import {
  Avatar,
  Box,
  Menu,
  MenuItem,
  Typography,
  TypographyProps,
  styled,
} from '@mui/material'

export const LogoContainer = styled('div')<{ background?: string | null }>`
  width: 40px;
  height: 62px;
  background-color: ${({ background }) => background || '#ffffff'};
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 8px;
`

export const HeaderText = styled(Typography)<
  TypographyProps & { component: React.ElementType }
>`
  font-size: 20px;
  color: #fff;
`

export const IconsItemsList = styled(Box)`
  height: 100%;
  width: 100%;
  min-width: 55px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 30px;
  padding-bottom: 25px;

  &:nth-of-type(1) {
    background-color: ${({ theme }) => theme.palette.primary.dark};
  }
`

export const ItemsList = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 30px;
  padding-bottom: 25px;

  &:nth-of-type(1) {
    background-color: ${({ theme }) => theme.palette.primary.dark};
  }
`

export const UserSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: auto;
  width: 100%;
`

export const StyledAvatar = styled(Avatar)`
  margin-left: 5px;
  width: 40px;
  height: 40px;
  cursor: pointer;
`

export const UsersData = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 40px;
  cursor: pointer;
  padding: 0 10px;
`

export const SitesContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  height: 45px;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  min-width: 150px;
  /* TODO: inject form theme */
  background-color: rgba(0, 0, 0, 0.1);
`

export const ShrinkedSitesContainer = styled(Box)`
  display: flex;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
`

export const IconContainer = styled(Link, {
  shouldForwardProp: (prop) =>
    prop !== 'isActive' &&
    prop !== 'isSettingsOpen' &&
    prop !== 'isSideNavOpen' &&
    prop !== 'subRoutesCount',
})<{
  isActive: boolean
  isSettingsOpen?: boolean
  isSideNavOpen?: boolean
  subRoutesCount?: number
}>`
  margin-left: 5px;
  min-width: 40px;
  min-height: 40px;
  width: 40px;
  height: 40px;
  border: 1px solid #fff;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: ${({ isActive }) => isActive && '#fff'};
  margin-bottom: ${({ isSettingsOpen, isSideNavOpen, subRoutesCount = 0 }) =>
    isSettingsOpen && isSideNavOpen && `${45 * subRoutesCount}px`};
  transition: 274ms;
  svg {
    fill: transparent;
  }
`

export const StyledLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>`
  display: flex;
  justify-content: center;
  height: 40px;
  color: #fff;
  text-decoration: none;
  text-align: left;
  font-weight: ${({ isActive }) => (isActive ? 800 : 400)};
  flex-direction: column;
`

export const SubRouteLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  height: 40px;
  color: #fff;
  text-decoration: none;
  text-align: left;
  opacity: 0.9;
  font-size: 13px;
  white-space: nowrap;
  font-weight: ${({ isActive }) => (isActive ? 800 : 400)};
`

export const NestedContainer = styled('div')`
  display: flex;
  flex-direction: column;
`

export const MenuTitle = styled('div')`
  padding: 5px 10px;
`

export const StyledMenuItem = styled(MenuItem)`
  height: 20px;
`

export const StyledMenu = styled(Menu)`
  && {
    & .MuiPaper-root {
      min-width: 150px;
    }
  }
`

export const NestedIconContainer = styled('div')`
  display: flex;
  align-items: center;
`
